// @vendors
const Immutable = require('immutable');
const moment = require('moment');

// @constans
const actionTypes = require('../raConstants/actionTypes');
const {
    RA_MOVEMENTS_FILTER_ALL,
    STATUS_PENDING,
} = require('../raConstants/index');
const { DATE_FILTER_FORTNIGHTLY } = require('constants/index');

const initialState = Immutable.fromJS({
    lastMovement: {
        transactions: [],
    },
    isFetching: false,
    error: false,
    lastMovementsRow: {
        filter: {
            isTypeModalValueFilterActive: false,
            typeModalValue: RA_MOVEMENTS_FILTER_ALL,
            profileId: '',
            date: {
                isActive: false,
                selected: DATE_FILTER_FORTNIGHTLY,
                from: moment()
                    .startOf('day')
                    .subtract('2', 'weeks'),
                to: moment().startOf('day'),
            },
        },
    },
});

const sortByStatusAndDate = data => {
    data.transactions.sort((item1, item2) => {
        if (item2['status'] === STATUS_PENDING) {
            return 1;
        }
        if (item1['status'] === STATUS_PENDING) {
            return -1;
        }
        return new Date(item2['bookingDate']) - new Date(item1['bookingDate']);
    });
    return data;
};

const RALastMovement = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_LAST_MOVEMENT_CHANGE_FILTER:
            if (action.payload.key === 'DateValue') {
                return state.mergeIn(['lastMovementsRow', 'filter'], {
                    date: {
                        isActive: false,
                        selected: DATE_FILTER_FORTNIGHTLY,
                        from: moment()
                            .startOf('day')
                            .subtract('2', 'weeks')
                            .format(),
                        to: moment()
                            .startOf('day')
                            .format(),
                    },
                });
            } else {
                return state.mergeIn(['lastMovementsRow', 'filter'], {
                    typeModalValue: action.payload.value,
                    isTypeModalValueFilterActive: false,
                });
            }
        case actionTypes.RA_GET_LAST_MOVEMENT_REQUEST:
            return state.merge({
                isFetching: true,
                error: false,
                lastMovement: {
                    transactions: [],
                },
            });
        case actionTypes.RA_GET_LAST_MOVEMENT_SUCCESS:
            if (action.payload.portfolioId != null) {
                let newState = state;
                newState = newState.merge({
                    lastMovement: sortByStatusAndDate(action.payload.data),
                    isFetching: false,
                });
                newState = newState.mergeIn(
                    ['lastMovementsRow', 'filter', 'profileId'],
                    action.payload.portfolioId,
                );
                return newState;
            } else {
                return state.merge({
                    lastMovement: sortByStatusAndDate(action.payload.data),
                    isFetching: false,
                });
            }

        case actionTypes.RA_GET_LAST_MOVEMENT_FAILURE:
            return state.merge({
                error: action.payload.error,
                isFetching: false,
            });
        case actionTypes.RA_GET_LAST_MOVEMENT_SET_FILTER:
            return state.mergeIn(
                ['lastMovementsRow', 'filter'],
                action.payload.filter,
            );
        case actionTypes.RA_LAST_MOVEMENT_CLAER_FILTER:
            return state.merge(initialState);
        default:
            return state;
    }
};

module.exports = RALastMovement;
